<template>
	<nk-multi-currency :options="settings" v-model="local_value" @update:modelValue="onValueChanged"></nk-multi-currency>
</template>

<script>
	import _ from 'lodash'

	export default {
		props: {
			modelValue: { type: Array, default: () => ([]) },
			options: { type: Object }
		},
		emits: ['update:modelValue'],
		data() {
			return {
				local_value: null,
				settings: {
					targetValuePropertyName: '',
					inputClasses: { 'text-right': true }
				}
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge({}, this.settings, val)
				}
			},
			modelValue: {
				immediate: true,
				handler(val) {
					this.local_value = val
				}
			}
		},
		methods: {
			onValueChanged(items) {
				//console.log('items',items)
				this.$emit('update:modelValue', items)
			}
		},
	}
</script>
